module.exports = __webpack_public_path__ + "images/ab38207cfb17d105a938c56078d648cf.svg";